
export enum StateEnum {
    add = 1,
    edit = 2,
    delete = 3,
    select = 4
}